export default function CsharpWriteline() {
  return (
    <h2>Csharp WriteLine</h2>
  );
}
